import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  CircularProgress
} from "@mui/material";

import { collection, getDocs, limit, orderBy, query, where } from "firebase/firestore";
import { db } from "../../firebase";

function Whatsapphistory() {

  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMessages();
  }, []);

  const loadMessages = async () => {
    try {
      // 🔥 Fetch only SENT messages
      const q = query(
        collection(db, "whatsapp_history"),
        where("status", "==", "Sent"),
        orderBy("createdAt", "desc"),
        limit(300)
      );

      const snap = await getDocs(q);

      const data = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setMessages(data);
      setLoading(false);

    } catch (err) {
      console.error("WhatsApp History Error:", err);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box p={1}>

      {/* HEADER */}
      <Typography variant="h5" fontWeight="bold" mb={2}>
        WhatsApp Sent History
      </Typography>

      {/* COUNT */}
      {/* <Paper sx={{ p: 2, mb: 2, borderRadius: 3 }}>
        <Typography variant="h6">
          Total Sent Messages:{" "}
          <span style={{ color: "green", fontWeight: "bold" }}>
            {messages.length}
          </span>
        </Typography>
      </Paper> */}

      {/* TABLE */}
      <Paper sx={{ borderRadius: 3 }}>
        <Table size="small">

          <TableHead sx={{ background: "#f5f5f5" }}>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Mobile</TableCell>
              {/* <TableCell>Customer Name</TableCell> */}
              <TableCell>Date</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {messages.length > 0 ? (
              messages.map((msg, index) => (
                <TableRow
                  key={msg.id}
                  hover
                  sx={{
                    backgroundColor: "#e8f5e9", // light green highlight
                  }}
                >
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    {msg.type || msg.templateName || "-"}
                  </TableCell>

                  <TableCell>{msg.mobile || "-"}</TableCell>
                  {/* <TableCell>{msg.custommerName || "-"}</TableCell> */}

                  

                  <TableCell>
                    {msg.createdAt?.toDate
                      ? msg.createdAt.toDate().toLocaleString()
                      : "-"}
                  </TableCell>

                  <TableCell>
                    <Chip
                      label="Sent"
                      size="small"
                      sx={{
                        backgroundColor: "#2e7d32",
                        color: "#fff",
                        fontWeight: "bold"
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No Sent Messages Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>

        </Table>
      </Paper>

    </Box>
  );
}

export default Whatsapphistory;